import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { TripProps } from '../api/response';
import { formatDatePayload } from '../utils/DateHelper';

interface SearchTripParamsProps {
  fromLocationSlug?: string;
  toLocationSlug?: string;
  serviceSlug: string;
  passenger?: number;
  date?: Date | undefined;
}

export const useSearchTripQuery = (
  { serviceSlug, fromLocationSlug, toLocationSlug, date, passenger }: SearchTripParamsProps,
  options?: UseQueryOptions,
) => {
  const axios = useAxios();
  return useQuery<AxiosResponse<AxiosResponse<TripProps[], any>, any>, AxiosError, any, any>(
    ['search-trip', date],
    () =>
      axios.get<AxiosResponse<TripProps[]>>(
        `${ApiRoutes.search}/${serviceSlug}/${fromLocationSlug}/${toLocationSlug}`,
        {
          params: {
            date: formatDatePayload(date),
            passenger_count: passenger,
          },
        },
      ),
    {
      select: res => res.data.data,
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
      retry: USE_QUERY_CONSTANTS.retry,
      onError: options?.onError,
      onSuccess: options?.onSuccess,
    },
  );
};
